import React from 'react';

export function GlassCard({ children, className = '', dark = false, hover = false, ...props }) {
  return (
    <div
      className={`rounded-2xl transition-base ${dark ? 'glass-dark' : 'glass'} ${
        hover ? 'card-hover' : ''
      } ${className}`}
      {...props}
    >
      {children}
    </div>
  );
}

export function ScoreRing({ value = 0, size = 132, stroke = 12, color = '#7C3AED', label = 'Health Score' }) {
  const radius = (size - stroke) / 2;
  const circ = 2 * Math.PI * radius;
  const pct = Math.max(0, Math.min(100, value));
  const offset = circ - (pct / 100) * circ;
  return (
    <div className="relative grid place-items-center" style={{ width: size, height: size }}>
      <svg width={size} height={size} className="-rotate-90">
        <circle cx={size / 2} cy={size / 2} r={radius} stroke="rgba(124,58,237,0.12)" strokeWidth={stroke} fill="none" />
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          stroke={color}
          strokeWidth={stroke}
          fill="none"
          strokeLinecap="round"
          strokeDasharray={circ}
          strokeDashoffset={offset}
          style={{ transition: 'stroke-dashoffset 1s cubic-bezier(0.22,1,0.36,1)' }}
        />
      </svg>
      <div className="absolute text-center">
        <div className="font-display text-4xl leading-none" style={{ color }}>
          {Math.round(pct)}
        </div>
        <div className="text-[11px] uppercase tracking-wider text-[var(--aura-ink-soft)] mt-1">{label}</div>
      </div>
    </div>
  );
}
